export var AUMInsuranceColumnsList = [
    {
        title: "Policy ID/ISIN",
        key: "Policy ID/ISIN",
    },
    {
        title: "Policy Name",
        key: "Policy Name",
    },
    {
        title: "Instrument Type",
        key: "Instrument Type",
    },
    {
        title: "Policy Date",
        key: "Policy Date",
    },
    {
        title: "Term",
        key: "Term",
    },
    {
        title: "Schedule",
        key: "Schedule",
    },
    {
        title: "Premium Annualized",
        key: "Premium Annualized",
    },
    {
        title: "Amount Invested",
        key: "Amount Invested",
    },
    {
        title: "Current Valuation",
        key: "Current Valuation",
    },
    {
        title: "Next Due Date",
        key: "Next Due Date",
    },
    {
        title: "Payment Mode",
        key: "Payment Mode",
    },
    {
        title: "Status",
        key: "Status",
    },
];
